import type { ReactElement } from "react";

import { useDispatch } from "react-redux";

import {
    setSelectedRowsAction,
    tableRowsSelectionToggledAction,
} from "app/pages/sales-intelligence/modules/company-analysis/store/competitors/action-creators";
import SaveToListTooltipContent from "app/pages/sales-intelligence/sub-modules/opportunities/components/table-actions-panel/SaveToListTooltipContent/SaveToListTooltipContent";
import { translate } from "app/filters/i18nFilter";
import OpportunityListUpdatedModalContainer from "app/pages/sales-intelligence/common-components/OpportunityListUpdatedModal/OpportunityListUpdatedModalContainer";
import SaveToListButtonBaseContainer from "app/pages/sales-intelligence/sub-modules/opportunities/containers/SaveToListButton/SaveToListButtonBaseContainer";
import type { TableActionProps } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/components/TableActionsPanel/types";

import { SaveToListCompetitorsPanel } from "./SaveToListCompetitorsPanel";

const TooltipContent = (props: { isOutOfQuota: boolean }): ReactElement => {
    return (
        <SaveToListTooltipContent
            isOutOfQuota={props.isOutOfQuota}
            i18nKeyModifier="account"
        />
    );
};

export const SaveToListCompetitorsButton = (props: TableActionProps): ReactElement => {
    const dispatch = useDispatch();

    const clearSelectionAndClosePanel = () => {
        dispatch(setSelectedRowsAction([]));
        dispatch(tableRowsSelectionToggledAction(false));
    };

    return (
        <>
            <OpportunityListUpdatedModalContainer
                title={translate("si.opportunity-list-updated-modal.title")}
                onClose={clearSelectionAndClosePanel}
            />
            <SaveToListButtonBaseContainer
                isDisabled={props.isDisabled}
                renderTooltipContent={TooltipContent}
                onClick={() => {
                    props.onActivate(() => SaveToListCompetitorsPanel);
                }}
            />
        </>
    );
};
